import { a11yOnly } from "styles/global.css";

/**
 * @param {string} data - data to put on the clipboard
 */
export default (data) => {
  document.getSelection().removeAllRanges();

  const copyInput = document.createElement("input");
  copyInput.classList = a11yOnly;
  copyInput.style.position = "fixed";
  copyInput.style.bottom= 0;
  copyInput.style.left= 0;
  copyInput.value = data;
  document.body.appendChild(copyInput);
  copyInput.focus();
  copyInput.setSelectionRange(0, copyInput.value.length);

  if (document.queryCommandSupported("copy") && document.execCommand("copy")) {
    return true;
  }

  document.body.removeChild(copyInput);
};



// WEBPACK FOOTER //
// ./src/utils/clipboard.js